<template>
  <section :id="$style.basic_info">
    <main-title
      :class="$style.title"
      :main_title="'基本情報'"
      :sub_title="'Basic Infomation'"
      :color="'#403f3f'"
      :align="'center'"
    ></main-title>

    <div :id="$style.info_area">
      <div :id="$style.left_area">
        <main-title
          :class="$style.name_title"
          :main_title="'松井 秀喜'"
          :sub_title="'Hideki Matsui'"
          :color="'#403f3f'"
          :align="'left'"
        ></main-title>
        <div :id="$style.info_table">
          <!-- 身長・体重など -->
          <table :id="$style.body_shape_info">
            <tr v-for="(item) in body_shape_info" :key="item.id">
              <td>{{ item.title }}：</td>
              <td>{{ item.info }}</td>
            </tr>
          </table>
          <!-- 生年月日・野球など -->
          <table :id="$style.baseball_info">
            <tr v-for="(item) in baseball_info" :key="item.id">
              <td>{{ item.title }}：</td>
              <td :class="$style.basic_info_detail">{{ item.info }}</td>
            </tr>
          </table>
        </div>
        <figure :id="$style.sign_pic"></figure>
      </div>

      <div :id="$style.right_area"></div>
    </div>
  </section>
</template>

<script lang="ts">
import Vue from "vue";
import MainTitle from "@/components/atoms/MainTitle.vue";

export default Vue.extend({
  name: "BasicInfoVisual",

  components: {
    MainTitle
  },

  data() {
    return {
      body_shape_info: [
        {
          title: "身長",
          info: "188cm"
        },
        {
          title: "体重",
          info: "105kg"
        },
        {
          title: "肩幅",
          info: "52cm"
        },
        {
          title: "ウェスト",
          info: "90cm"
        },
        {
          title: "血液型",
          info: "O型"
        },
        {
          title: "視力",
          info: "右1.5 左1.5"
        },
        {
          title: "足のサイズ",
          info: "29cm"
        }
      ],
      baseball_info: [
        {
          title: "生年月日",
          info: "1974年（昭和49年）6月12日"
        },
        {
          title: "出身地",
          info: "石川県"
        },
        {
          title: "出身校",
          info: "星稜高校"
        },
        {
          title: "投打",
          info: "右投・左打"
        },
        {
          title: "ポジション",
          info: "外野手"
        },
        {
          title: "ニックネーム",
          info: "ゴジラ"
        },
        {
          title: "好きな食べ物",
          info: "寿司"
        }
      ]
    };
  }
});
</script>

<style lang="scss" module>
@media only screen and (max-width: 1023px) {
  $sign_pic_width: 130px;
  $sing_pic_height: 80px;
  // $sign_pic_width: 200px;
  // $sing_pic_height: 100px;
  $hideki_pic_width: 130px;
  $hideki_pic_height: 280px;

  #basic_info {
    .title {
      margin-bottom: 30px;
    }
    #info_area {
      height: 100%;
      display: flex;
      justify-content: center;
      margin: 0px 5px;
      position: relative;
      #left_area {
        width: 100%;
        .name_title {
          text-align: center;
        }
        #info_table {
          display: flex;
          justify-content: center;
          font-size: 15px;
          flex-wrap: wrap;
          flex-direction: column;
          margin-left: 9vw;
          position: relative;
          z-index: 1;
          table {
            margin: 5px;
            // 縦に積む
            display: flex;
            flex-direction: column;
            flex-wrap: wrap;
            tr {
              margin: 1px 0;
              td {
                min-width: 58px;
              }
            }
          }
          table:nth-child(2) tr:nth-child(1) td:nth-child(2) {
            min-width: 127px;
          }
        }
        #sign_pic {
          background-image: url("../../../assets/img/sign.png");
          background-size: $sign_pic_width $sing_pic_height;
          background-repeat: no-repeat;
          margin-top: 0;
          width: $sign_pic_width;
          height: $sing_pic_height;
          position: absolute;
          bottom: 37px;
          right: 4vw;
          margin: 0;
        }
      }
      #right_area {
        background-image: url("../../../assets/hideki.png");
        background-size: $hideki_pic_width $hideki_pic_height;
        background-repeat: no-repeat;
        margin: 0;
        width: $hideki_pic_width;
        height: $hideki_pic_height;
        position: absolute;
        right: 13px;
        // left: 50vw;
        top: 50px;
      }
    }
  }
}
@media only screen and (min-width: 1024px) {
  $sign_pic_width: 300px;
  $sing_pic_height: 150px;
  $hideki_pic_width: 190px;
  $hideki_pic_height: 400px;

  #basic_info {
    .title {
      margin-bottom: 60px;
      text-align: center;
    }
    #info_area {
      height: 100%;
      display: flex;
      justify-content: center;
      #left_area {
        .name_title {
          margin-left: 125px;
        }
        #info_table {
          display: flex;
          justify-content: center;
          table {
            margin: 20px;
            // 縦に積む
            display: flex;
            flex-direction: column;
            flex-wrap: wrap;
          }
        }
        #sign_pic {
          background-image: url("../../../assets/img/sign.png");
          background-size: $sign_pic_width $sing_pic_height;
          background-repeat: no-repeat;
          margin-top: 0;
          width: $sign_pic_width;
          height: $sing_pic_height;
        }
      }
      #right_area {
        background-image: url("../../../assets/hideki.png");
        background-size: $hideki_pic_width $hideki_pic_height;
        background-repeat: no-repeat;
        margin: 0;
        width: $hideki_pic_width;
        height: $hideki_pic_height;
      }
    }
  }
}
</style>
